import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/Home';
import { Layout, Spin } from 'antd';
import { useLayout } from './hooks/layout/LayoutContext';
import { useIntl } from 'react-intl';
const { Content } = Layout;

const AppProtected = () => {
    const intl = useIntl();
    const { layoutState } = useLayout();

    return (<Spin tip={intl.formatMessage({ id: "SPINNER_TIP" })} spinning={layoutState.showLoading}>
        <Layout className="app-container">
            <Layout className="site-layout">
                <Content className="site-layout-background">
                    <Routes>
                        <Route path='' element={<Home />} />
                    </Routes>
                </Content>
            </Layout>
        </Layout>
    </Spin>);
}

export default AppProtected;